import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/** Gates a route behind authentication.
 *
 *  Phase 2G · during product privatization the default redirect target is `/`
 *  (the public cover page). Pass `redirectTo="/login?next=…"` to opt back
 *  into the login funnel — used by nothing today but kept for a clean
 *  swap-back when the product goes public again.
 */
export const RequireAuth = ({ children, redirectTo = "/" }) => {
    const { status } = useAuth();
    const location = useLocation();

    if (status === "loading") {
        return (
            <div
                data-testid="auth-checking"
                className="min-h-screen flex items-center justify-center bg-[#f6f7f6]"
            >
                <div className="tc-mono text-[11px] text-[#5a6669] tracking-widest uppercase">
                    Checking session…
                </div>
            </div>
        );
    }

    if (status !== "authenticated") {
        // Preserve the requested URL so once product goes public the login
        // funnel can restore ?next= behavior with a single-line revert.
        const _next = encodeURIComponent(location.pathname + location.search);
        void _next;
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};

export default RequireAuth;
